module.exports = __webpack_public_path__ + "static/img/icon-mall-private.115d43bc.png";